<script setup>
import { computed, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

const logoThumbnailSrc = computed(() => {
  const logoThumbnail = globalConfig.logoThumbnail;
  if (typeof logoThumbnail !== 'string' || !logoThumbnail) {
    return '/brand-assets/logo_thumbnail.svg';
  }

  return logoThumbnail.replace(
    /(\/brand-assets\/logo_thumbnail)\.png(\?.*)?$/,
    '$1.svg$2'
  );
});

const installationName = computed(
  () => globalConfig.value?.installationName || 'Chatmigo'
);

const hasCustomThumbnail = computed(
  () => typeof globalConfig.value?.logoThumbnail === 'string'
);

const brandInitials = computed(() => {
  const words = installationName.value
    .split(/\s+/)
    .map(word => word.trim())
    .filter(Boolean);

  if (!words.length) return 'C';
  if (words.length === 1) return words[0].slice(0, 1).toUpperCase();

  return `${words[0][0]}${words[1][0]}`.toUpperCase();
});
</script>

<template>
  <div
    v-bind="attrs"
    class="chatmigo-brand-mark"
    :aria-label="installationName"
    role="img"
  >
    <img
      v-if="hasCustomThumbnail"
      :src="logoThumbnailSrc"
      :alt="installationName"
      class="chatmigo-brand-mark-image"
    />
    <span v-else class="chatmigo-brand-fallback">
      {{ brandInitials }}
    </span>
  </div>
</template>
